import styled, { css } from "styled-components";

export const PopupWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;

export const PopupContainer = styled.div`
  background: white;
  border-radius: 10px;
  width: 100%;
  max-width: 450px;
  margin: 10% 10%;
  padding: 25px;
  position: relative;
`;

export const Paragraph = styled.p`
  margin: none;
  padding: none;
  text-align: left;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.mediumGray};
`;

export const QuestionTitle = styled.p`
  font: 16px;
  color: ${({ theme }) => theme.colors.blue};
  margin: 16px 0 14px;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 25px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
`;

export const ContentRight = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  & svg {
    color: ${({ theme }) => theme.colors.blue};
  }
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 18px;
  font-family: "Mangueira Bold";
`;

export const Counter = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray};
`;

export const ContentButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
`;

export const TryAgainButton = styled.button`
  &.wrap-button {
    font-weight: bold;
    color: white;
    width: 11.4375rem;
    height: 3.5625rem;
    background: #3d8bff;
    border: 0.0625rem solid #3d8bff;
    border-radius: 4px;
  }
`;

type IAnswerForm = {
  initialState: boolean;
};

export const AnswerForm = styled.form<IAnswerForm>`
  display: flex;
  justify-content: space-between;

  ${({ initialState }) =>
    !initialState &&
    css`
      flex-direction: column;
      align-items: flex-start;
    `}
`;

export const AttemptsLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  p {
    margin-bottom: 0;
    text-align: center;
  }
`;

export const TryAgainButtonWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end !important;
  margin-top: 18px;
`;
